export default () =>
  ({
    default: {
      asterisk: {
        fontWeight: 600,
        paddingInlineStart: '8px',
      },
    },
  }) as const
